"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PodcastStore = /*#__PURE__*/function (_RootStore) {
  function PodcastStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, PodcastStore);
    _this = _callSuper(this, PodcastStore);
    _this.config = {
      model: _models.Podcast,
      deserialize: true,
      GET: {
        index: '/podcasts',
        show: '/podcasts/:podcastId',
        membershipSyncStatus: '/podcasts/:podcastId/membership_sync_status'
      },
      POST: {
        create: '/podcasts',
        importRssFeed: '/podcasts/:podcastId/import_rss_feed'
      },
      PUT: {
        update: '/podcasts/:podcastId',
        updateRssFeeds: '/podcasts/:podcastId/update_rss_feeds',
        updateMembershipTypes: '/podcasts/:podcastId/update_membership_types'
      },
      DELETE: {
        destroy: '/podcasts/:podcastId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(PodcastStore, _RootStore);
  return (0, _createClass2["default"])(PodcastStore, [{
    key: "updateRssFeeds",
    value: function updateRssFeeds(params, callback) {
      this.api(params, callback, 'PUT', 'updateRssFeeds');
    }
  }, {
    key: "importRssFeed",
    value: function importRssFeed(params, callback) {
      this.api(params, callback, 'POST', 'importRssFeed');
    }
  }, {
    key: "updateMembershipTypes",
    value: function updateMembershipTypes(params, callback) {
      this.api(params, callback, 'PUT', 'updateMembershipTypes');
    }
  }, {
    key: "updateMembershipTypesPromise",
    value: function updateMembershipTypesPromise(params) {
      return this.apiPromise(params, 'PUT', 'updateMembershipTypes');
    }
  }, {
    key: "getMembershipSyncStatusPromise",
    value: function getMembershipSyncStatusPromise(params) {
      return this.apiPromise(params, 'GET', 'membershipSyncStatus');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new PodcastStore();